/**
 * Cross Sell common component. Contains methods needed by both the game and app launcher
 *
 * @module app/components/crossSell/CrossSellCommon
 */
import DeviceDetector from '../DeviceDetector';



/**
 * @returns {string}
 */
// eslint-disable-next-line complexity
var getTrackingFunnel = function getTrackingFunnel() {

    var funnel = 'trafalgar';

    if (DeviceDetector.isNative()) {
        funnel = 'native';
    }
    else if (DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
        funnel = 'mobile_web';
    }

    return funnel;
};

/**
 * Contains functions exposed by this component as an API.
 *
 * @type {Object}
 *
 * @public
 */
var api = {
    getTrackingFunnel: getTrackingFunnel,
};

export default api;
